import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	detailsWrap: 'js-m-talks__details-wrap',
	details: 'js-m-talks__details',
	listButton: 'js-m-talks__list-button',
	stateButtonActive: 'state-m-talks__list-button--active',
	list: 'js-m-talks__list',
	accordionButton: 'js-m-talks__accordion',
	stateAccordionOpen: 'state-m-talks__accordion--active',
	leftImage: 'm-talks__left-image',
	leftImageItem: 'js-m-talks__left-image-item',
	statImageVisible: 'state-m-talks__left-image-item--visible',
};

@createModule('Talks')
/**
 * talks module implementation.
 *
 */
export class Talks extends TerrificSpec {
	$ctx: JQuery;
	$detailsWrap: JQuery;
	$details: JQuery;
	$listButton: JQuery;
	$list: JQuery;
	$accordionButton: JQuery;
	$leftImage: JQuery;
	$leftImageItem: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$detailsWrap = this.$ctx.find(`.${classes.detailsWrap}`);
		this.$details = this.$ctx.find(`.${classes.details}`);
		this.$list = this.$ctx.find(`.${classes.list}`);
		this.$listButton = this.$ctx.find(`.${classes.listButton}`);
		this.$accordionButton = this.$ctx.find(`.${classes.accordionButton}`);
		this.$leftImage = this.$ctx.find(`.${classes.leftImage}`);
		this.$leftImageItem = this.$ctx.find(`.${classes.leftImageItem}`);

		this.$leftImageItem.eq(0).addClass(classes.statImageVisible);
		this.$listButton.eq(0).addClass(classes.stateButtonActive);
		this.$details.attr('data-talk-selected', 0);

		this.setHeight();
		$(window).on('resize', this.setHeight.bind(this));

		this.$listButton.on('click', this.onTriggerClick.bind(this));
		this.$accordionButton.on('click', this.accordionToggle.bind(this));

		resolve();
	}

	// Set the background of color black
	setHeight() {
		this.$details.css('max-height', this.$details.children(".m-talks__accordion-panel")[0].offsetHeight);
		setTimeout(() => {
			if(this.$leftImage.length > 0) {
				this.$detailsWrap.css('min-height', this.$list.height() + 412);
			} else {
				this.$detailsWrap.css('min-height', this.$list.height() - 20);
			}
		}, 300);
	}

	onTriggerClick(ev: any) {
		$(ev.currentTarget).parent().siblings().children().removeClass(classes.stateButtonActive);
		$(ev.currentTarget).addClass(classes.stateButtonActive);
		this.$details.attr('data-talk-selected', $(ev.currentTarget).parent().index());
		this.$leftImageItem.removeClass(classes.statImageVisible);
		this.$leftImageItem.eq($(ev.currentTarget).parent().index()).addClass(classes.statImageVisible);
		this.$details.css('max-height', this.$details.children(".m-talks__accordion-panel")[$(ev.currentTarget).parent().index()].offsetHeight);
	};

	accordionToggle(ev: any) {
		$(ev.currentTarget).siblings().removeClass(classes.stateAccordionOpen);
		$(ev.currentTarget).toggleClass(classes.stateAccordionOpen);
	};

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
